<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-17 12:30:46
 * @LastEditTime: 2019-08-17 12:46:20
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="storeDetail container">
        <div class="footer">
      <el-button type="primary" @click="back">返回</el-button>
    </div>
        <ul>
            <li v-if="detail.img_url">门店图片: <img :src="detail.domain_name+detail.img_url[0]" alt=""></li>
            <li>门店编号: <span>{{detail.store_sn}}</span></li>
            <li>门店名称: <span>{{detail.storename}}</span></li>
            <li>门店地址: <span>{{detail.address}}</span></li>
            <li>GPS位置: <span>{{detail.gps}}</span></li>
            <li>负责人名称:<span>{{detail.person}}</span> </li>
            <li>门店电话: <span>{{detail.mobile}}</span></li>
            <li>门店账号:<span>{{detail.mobile}}</span></li>
            <!-- <li>可访问国家地区: <span>{{detail.mobile}}</span></li> -->
            <li>人均价格: <span>{{detail.price}}</span></li>
            <li>营业时间: <span>{{detail.phone}}</span></li>
            <li>门店简介: <span>{{detail.msg}}</span></li>

        </ul>
        
    </div>
</template>

<script>
export default {
    name:'lowerStoreDetail',
    data(){
        return{
            detail:{}
        }
    },
    methods:{
        getDetail(){
            this.$get('logistics_2','/vstore/dealer_pc/lowerstoredetail',{
                id:this.$route.query.id,
                dealer_id:this.$route.query.dealer_id
            }).then(res=>{
                this.detail=res.data
            })
        },
        back() {
            this.$router.go(-1);
    },
        
    },
    created(){
        this.getDetail()
    }
}
</script>

<style lang="scss" scoped>
ul{
    padding: 40px 50px;
    li{
            color: #666;
    list-style: none;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    img{
        width: 10%;
        margin-left: 10px;
    }
    span{
        margin-left: 10px;
    }
    }
}
</style>